import React, { PropTypes } from 'react';
import classnames from 'classnames';

const ReputationTag = ({ user, extraClasses='' }) => {
  const eliteLabel = user.is_elite ? 'Elite' : '';
  const platinumLabel = user.is_platinum ? 'Platinum' : '';
  const reputationLabel = eliteLabel || platinumLabel;
  const classes = classnames("tag tag-highlight tag-sm", {
    "elite": eliteLabel,
    "platinum": platinumLabel && !eliteLabel
  }, extraClasses);

  if (!reputationLabel) {
    return null;
  }

  return <span className={classes}>{ reputationLabel }</span>;
}

ReputationTag.propTypes = {
  user: PropTypes.object.isRequired,
  extraClasses: PropTypes.string,
};

export default ReputationTag;



// WEBPACK FOOTER //
// ./common/components/reputation_tag.jsx